// @flow

import ko from 'rgs-knockout';

import { temporaryFileInfoToFromJSExtend } from 'ko-extender-to-from-js-temporary-file-info';


export function observableJSableFile (...args) {
	return ko.observable(...args)
		.extend({ toFromJS: true })
		.extend(temporaryFileInfoToFromJSExtend);
}